import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50bfad1d"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50bfad1d')) {
      api.createRecord('50bfad1d', component.options)
    } else {
      api.reload('50bfad1d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50bfad1d", function () {
      api.rerender('50bfad1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/salesPromotion/index.vue"
export default component.exports